"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deep_object_diff_1 = require("deep-object-diff");

var object_hash_1 = __importDefault(require("object-hash"));

var react_1 = __importStar(require("react"));

var redux_form_1 = require("redux-form");

var initializeValues_1 = __importDefault(require("../../utils/initializeValues"));

var Data_1 = __importDefault(require("../Data"));

var Render_1 = __importDefault(require("./Render"));

var Form = function Form(_ref) {
  var actions = _ref.actions,
      asyncChangeFields = _ref.asyncChangeFields,
      asyncValidate = _ref.asyncValidate,
      autosave = _ref.autosave,
      bodyProps = _ref.bodyProps,
      cancelProps = _ref.cancelProps,
      children = _ref.children,
      className = _ref.className,
      datas = _ref.datas,
      destroyOnUnmount = _ref.destroyOnUnmount,
      enableReinitialize = _ref.enableReinitialize,
      forceUnregisterOnUnmount = _ref.forceUnregisterOnUnmount,
      footerProps = _ref.footerProps,
      hideSubmitButton = _ref.hideSubmitButton,
      id = _ref.id,
      initialValues = _ref.initialValues,
      isSubmissive = _ref.isSubmissive,
      keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize,
      mode = _ref.mode,
      name = _ref.name,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      params = _ref.params,
      removePristine = _ref.removePristine,
      submitProps = _ref.submitProps,
      touchOnChange = _ref.touchOnChange,
      updateUnregisteredFields = _ref.updateUnregisteredFields,
      validate = _ref.validate;

  var _ref2 = (0, react_1.useState)(),
      _ref3 = _slicedToArray(_ref2, 2),
      timeoutId = _ref3[0],
      setTimeoutId = _ref3[1];

  var _ref4 = (0, react_1.useState)(),
      _ref5 = _slicedToArray(_ref4, 2),
      canBeSubmited = _ref5[0],
      setCanBeSubmited = _ref5[1];

  var newDatas = datas && !Array.isArray(datas) ? [datas] : datas;

  var handleOnChange = function handleOnChange(values, dispatch, props, previousValues) {
    if (onChange) {
      onChange(values, dispatch, props, previousValues);
    }

    if (autosave) {
      setCanBeSubmited(true);

      if (Object.keys((0, deep_object_diff_1.diff)(values, previousValues)).length > 0) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        setTimeoutId(setTimeout(function () {
          if (canBeSubmited) {
            dispatch((0, redux_form_1.submit)(name));
          }
        }, 1000));
      }
    }
  };

  return react_1.default.createElement(Render_1.default, {
    actions: actions,
    asyncChangeFields: asyncChangeFields,
    asyncValidate: asyncValidate,
    bodyProps: bodyProps,
    cancelProps: cancelProps,
    className: className,
    destroyOnUnmount: destroyOnUnmount,
    enableReinitialize: enableReinitialize,
    footerProps: footerProps,
    forceUnregisterOnUnmount: forceUnregisterOnUnmount,
    hideSubmitButton: hideSubmitButton,
    id: id,
    initialValues: initialValues || newDatas && (0, initializeValues_1.default)(newDatas),
    isSubmissive: isSubmissive,
    keepDirtyOnReinitialize: keepDirtyOnReinitialize,
    name: name,
    onChange: handleOnChange,
    onSubmit: onSubmit,
    removePristine: removePristine,
    submitProps: submitProps,
    touchOnChange: touchOnChange,
    updateUnregisteredFields: updateUnregisteredFields,
    validate: validate
  }, newDatas && newDatas.map(function (props, index) {
    return react_1.default.createElement(Data_1.default, _objectSpread(_objectSpread({
      key: (0, object_hash_1.default)(_objectSpread(_objectSpread({}, props), {}, {
        index: index,
        datas: null,
        params: null
      }))
    }, props), {}, {
      formName: name,
      mode: mode,
      params: params
    }));
  }), children);
};

exports.default = Form;